(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('EventsService', EventsService);

    EventsService.$inject = ['SoopkitchenUtils', '$http'];

    function EventsService(SoopkitchenUtils, $http) {

        return {
            moveEvents: moveEvents,
            updateMetisCompatibility: updateMetisCompatibility
        };

        function successMoveEvents(events, time, cut, extraCallback) {
            return function (response) {
                var verb = 'copied';
                if (cut) verb = 'moved';
                var title = "Events have been " + verb;
                var msg = events.length + " have been " + verb + " to " + time;
                SoopkitchenUtils.processResponse(
                    response,
                    title,
                    msg,
                    extraCallback(response)
                );
            }
        }

        function failure(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function moveEvents(planType, planLabel, events, anchorTime, cut, successCallback) {
            $http({
                method: 'PUT',
                url: 'api/' + planType + '/event/copy',
                params: {
                    'planLabel': planLabel,
                    'anchorDate': anchorTime,
                    'cut': cut
                },
                data: events
            }).then(successMoveEvents(events, anchorTime, cut, successCallback), failure);
        }

        function updateMetisCompatibility(planType, planLabel, startTime, endTime, compatibility, successCallback) {
            console.warn("updateMetisCompatibility");
            $http({
                method: 'PUT',
                url: 'api/' + planType + '/event/metis-compatibility',
                params: {
                    'planLabel': planLabel,
                    'startTime': startTime,
                    'endTime': endTime,
                    'compatibility': compatibility
                }
            }).then(successCallback, failure);
        }
    }
})();
